/**
 * @param {string} method - ("POST")
 * @param {string} path - ("/tan")
 * @param {string} [transactionId] - ID for path parameter
 * @param {string} [data] - request body for POST, PUT etc.
 * @param {string} [secondaryPath] ("/generate")
 * @param {string} [applyProductPath] - add brand, product etc to path (default: true)
 * @param {string} [resolveStatuses] - http statuses for promise resolve (default: [200])
 * @param {string} [onError] - method for error handling
 * @param {string} [customHandleReject] - if false, onError is used for Promise.reject (default: false)
 */
import { pathMod } from 'config'
import { getServiceBrandName } from 'services/brand'
import { history } from 'services/routing'
import { axios } from '.'
import { Analytics } from '../analytics'

const { REACT_APP_COUNTRYCODE, REACT_APP_PRODUCT, REACT_APP_ENTRYPOINT } = process.env

const DEFAULT_RESOLVE_STATUSES = [200, 201]

const fesRequest = props => {
  const {
    transactionId,
    method,
    data,
    path: primaryPath,
    secondaryPath = '',
    applyProductPath = true,
    resolveStatuses = DEFAULT_RESOLVE_STATUSES,
    onError = handleError,
    customHandleReject = false,
  } = props
  const productPath = applyProductPath
    ? `/${REACT_APP_PRODUCT}/${REACT_APP_COUNTRYCODE}/${getServiceBrandName()}/${REACT_APP_ENTRYPOINT}`
    : ''
  const transactionPath = transactionId ? `/${transactionId}` : ''

  const url = `${primaryPath}${productPath}${transactionPath}${secondaryPath}`

  return new Promise((resolve, reject) => {
    axios({
      method,
      url,
      data,
      validateStatus: statusCode => resolveStatuses.includes(statusCode),
    })
      .then(
        response => {
          const result = response?.status === 200 && response.data ? response.data : response
          resolve(result)
        },
        error => {
          if (!customHandleReject) {
            onError(error)
          }
          reject(error)
        }
      )
      .catch(error => {
        onError(error)
      })
  })
}

export const handleError = error => {
  let eventType = '404: Error'
  let eventAction = '404: Page not found'
  switch (error.response?.status) {
    case 401:
      eventType = '401: Login'
      eventAction = '401: Unauthorized'
      break
    case 403:
      eventType = '403: Access'
      eventAction = '403: Denied'
      break
    default:
      eventType = 'Error'
      eventAction = 'Technical error'
      break
  }

  Analytics.push({
    core: {
      pageInfo: {
        pageName: 'Error',
      },
      attributes: {
        viewChange: 'Error',
      },
    },
    error: {
      errorCode: error.response?.status,
      errorMessage: error.response?.data?.message || 'Backend or connection problem',
      errorCausingURL: '/',
    },
    event: 'page',
    eventInfo: [
      {
        eventType: 'pageView',
        eventAction: 'Success',
        eventTargetURL: null,
        linkInformation: null,
      },
      {
        eventType,
        eventAction,
        eventTargetURL: null,
        linkInformation: null,
      },
    ],
  })
}

export default fesRequest
